var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-danger"},[_c('i',{staticClass:"fa fa-trash fa-lg icon-button",attrs:{"title":"Desassociar Etapa"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarDesassociar(_vm.pagamentoEtapa.pagamentoEtapaId)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }